module.exports = __webpack_public_path__ + "img/bg.63bbc82a.png";